import Vue from 'vue'
import Store from '../../store/index.js'
export default {
  setSearchConfig(sampleData) {
    let v = new Vue()
    // 设置返回对象
    let searchConfig = {
      mainSearchList: [], // 第一行搜索对象
      showMore: false, // 是否显示高级搜索
      detailSearchList: [] // 详细行搜索
    }
    // 克隆核心配置区域
    let list = v.$utils.clone(sampleData.allList)
    searchConfig.showMore = sampleData.config.queryList.length > 3
    // 搜索区域获得字段详情
    let queryDetailList = list.filter(m => sampleData.config.queryList.includes(m.model))

    // 对搜索区域数据进行设置
    queryDetailList.forEach(function(item, key) {
      if (key < 3) {
        //小于3个的查询条件，推入mainSearchList
        searchConfig.mainSearchList.push(item)
      } else {
        //大于3个的查询条件，推入detailSearchList
        searchConfig.detailSearchList.push(item)
      }
    })
    return searchConfig
  },
  setTableConfig(sampleData) {
    let v = new Vue()
    let that = this
    // 设置返回对象
    let tableConfig = {
      rowList: []
    }

    // 克隆核心配置区域
    let list = v.$utils.clone(sampleData.allList)
    // 获得表格展示列
    let rowList = list.filter(t => sampleData.config.showList.includes(t.model))
    rowList.forEach(function(item) {
      // 给所有的项目加上标识，文本是否需要转化
      item.textChange = false
      // 获得数据配置详情
      let optionsModel = item.options

      // 配置模型存在dynamic 属性,开启了动态获取数据功能
      if (optionsModel.hasOwnProperty("dynamic")) {
        // 设置为需要改变文本模式
        item.textChange = true
        that.getOptionsList(optionsModel)
      }
    })
    tableConfig.rowList = rowList

    return tableConfig
  },
  // 根据optionsModel 获得对应的数组，实现id转文字
  getOptionsList(optionsModel) {
    let that = this
    // 设置默认转化列表
    optionsModel.optionsList = []
    // dynamic == 0 静态数据模式,返回配置里的静态数据
    if (optionsModel.dynamic == 0) {
      optionsModel.optionsList = optionsModel.options
    } else {
      // dynamic == 1 动态数据模式,读取接口，返回数据
      // 根据模型对象，获得远程数据
      let promiseOptions = that.getRemoteData(optionsModel)
      promiseOptions.then(data => {
        console.log(data);
        // 赋值
        optionsModel.optionsList = data
      })
    }
    // dynamic == 1 动态数据模式，读取接口
  },
  // 加载动态数据
  async getRemoteData(optionsModel) {
    let v = new Vue()
    let optionParams = v.$utils.dynamicFun(optionsModel.dataPath, v)
    let params = {
      pageIndex: 1,
      pageSize: 99999
    }

    for (let key in optionParams) {
      params[key] = optionParams[key]
    }

    // 动态解析请求地址
    let url = v.$utils.dynamicFun(optionsModel.remoteFunc, v)
    let optionList = []
    // 获得返回数据
    await v.$http.post(url, params).then(res => {
      //调用loading计数器
      Store.commit("reduceSesignLoadCount", "")
      optionList = res.data.data
    })
    // 返回
    return optionList
  },
  // 根据配置数据的list属性，解构为平铺的数组allList
  getAllList(list) {
    let v = new Vue()
    let allList = []
    // 克隆配置项目
    let cloneList = v.$utils.clone(list)

    // 循环配置
    cloneList.forEach(function(item) {
      // 解构grid 布局
      if (item.type == "grid") {
        item.columns.forEach(function(rowItem) {
          allList = [...allList, ...rowItem.list]
        })
      } else {
        allList.push(item)
      }
    })
    return allList
  },
  // 将配置对象的allList的数据同步到list对应的对象中
  setAllToDataList(allList, list) {
    let v = new Vue()
    list.forEach(function(item) {
      // 解构grid布局
      if (item.type == "grid") {
        item.columns.forEach(function(rowItem) {
          rowItem.list.forEach(function(rItem) {
            // allList中找到对应的对象
            let fModel = allList.find(m => m.key == rItem.key)
            if (fModel) {
              // 全属性拷贝
              v.$utils.CopyAllPro(fModel, rItem)
            }
          })
        })
      } else {
        // 非grid布局，直接寻找对应的对象
        let fModel = allList.find(m => m.key == item.key)
        if (fModel) {
          // 全属性拷贝
          v.$utils.CopyAllPro(fModel, item)
        }
      }
    })
  },
  // 设置formRow对象数组数据
  setFormRowList(sampleData) {
    let v = new Vue()
    // 获得数据
    let dataModel = v.$utils.clone(sampleData)
    // 行渲染数组，数据格式为[[],[]]
    // 每个数组元素代表一行
    // 每一行离存放若干元素
    let formRowList = []
    dataModel.list.forEach(function(item) {
      // grid 布局
      if (item.type == "grid") {
        // 解构grid布局数据 
        let newRowList = []
        // 将当前行中columns属性下的list 属性都整理出来
        item.columns.forEach(function(rowItem) {
          newRowList = [...newRowList, ...rowItem.list]
        })
        formRowList.push(newRowList)
      } else {
        // 非grid布局，单独占一行
        formRowList.push([item])
      }
    })
    return formRowList
  },
  // 设置query对象值
  setQueryValue(queryModel, formModel, sampleData) {
    for (let key in queryModel) {
      let fModel = sampleData.allList.find(m => m.model == key)
      if (fModel && fModel.queryColumn) {
        formModel[key] = queryModel[key]
      }
    }
  },
  // info接口，将获得的数据赋值给form对象
  setFormInfoDate(sampleData, data) {
    let v = new Vue()
    // 返回对象
    let reModel = {}
    // 获得数据
    let dataModel = v.$utils.clone(sampleData)
    // 循环info的数据对象
    for (let key in data) {
      // 获得当前key对应的值
      let dataValue = data[key]
      // 将当前key值赋予给返回对象
      reModel[key] = dataValue
      // 找出当前key对应的配置对象
      let model = dataModel.allList.find(m => m.model == key)
      if (model) {
        //处理特殊类型赋值 datePicker
        if (model.type == "datePicker") {
          reModel[key] = v.$utils.dateToStrAll(dataValue)
        }
      }

    }
    return reModel
  },
  // 设置表单默认值
  setFormDefaultValue(formModel, sampleData) {
    let v = new Vue()
    // 获得数据
    let dataModel = v.$utils.clone(sampleData)
    // 循环allList,判断每一列的值
    dataModel.allList.forEach(function(item) {
      let defaultValue = item.options.hasOwnProperty("defaultValue") ? item.options.defaultValue : ""
      if (defaultValue) {
        formModel[item.model] = defaultValue
      }
    })
    console.log(formModel);
  },
  // 设置表单默认值-手机端独有方法
  setFormRules(sampleData) {
    let v = new Vue()
    // 获得数据
    let dataModel = v.$utils.clone(sampleData)
    // 循环allList,判断每一列的值
    dataModel.allList.forEach(function(item) {
      let ruleList = item.rules
      ruleList.forEach(function(rItem) {
        if (rItem.hasOwnProperty("trigger")) {
          delete rItem.trigger
        }
      })
    })
    return dataModel.allList
  },
  // 日期字符串格式转化
  // 获得日期格式 yyyy-MM-dd hh:mm:ss
  dateFormatAll(date) {
    const now = date
    const year = now.getFullYear();
    let month = now.getMonth() + 1;
    let day = now.getDate();
    let hour = now.getHours();
    let minutes = now.getMinutes();
    let seconds = now.getSeconds();
    String(month).length < 2 ? (month = "0" + month) : month;
    String(day).length < 2 ? (day = "0" + day) : day;
    String(hour).length < 2 ? (hour = "0" + hour) : hour;
    String(minutes).length < 2 ? (minutes = "0" + minutes) : minutes;
    String(seconds).length < 2 ? (seconds = "0" + seconds) : seconds;
    return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
  },
  // 日期字符串格式转化
  // 获得日期格式 yyyy-MM-dd
  dateFormatYMD(date) {
    const now = date
    const year = now.getFullYear();
    let month = now.getMonth() + 1;
    let day = now.getDate();
    String(month).length < 2 ? (month = "0" + month) : month;
    String(day).length < 2 ? (day = "0" + day) : day;
    return `${year}-${month}-${day}`;
  },
}
